import React from "react";
import ReactApexChart from "react-apexcharts";

const BoxPlotChart = () => {
  const chartData = {
    series: [
      {
        name: "Box",
        type: "boxPlot",
        data: [
          {
            x: "Alice",
            y: [54, 66, 69, 75, 88],
            goals: [
              {
                value: 32,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
            ],
          },
          {
            x: "Bob",
            y: [43, 65, 69, 76, 81],
            goals: [
              {
                value: 35,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
              {
                value: 95,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
            ],
          },
          {
            x: "Charlie",
            y: [31, 39, 45, 51, 59],
            goals: [
              {
                value: 64,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
              {
                value: 75,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
            ],
          },
          {
            x: "David",
            y: [39, 46, 55, 65, 71],
            goals: [
              {
                value: 27,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
              {
                value: 77,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
            ],
          },
          {
            x: "Ahmed",
            y: [29, 31, 35, 39, 44],
            goals: [
              {
                value: 10,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
              {
                value: 56,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
              {
                value: 62,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
              {
                value: 98,
                strokeWidth: 0,
                strokeHeight: 13,
                strokeLineCap: "round",
                strokeColor: "#FEB019",
              },
            ],
          },
        ],
      },
    ],
    options: {
      chart: {
        type: "boxPlot",
        height: 300,
      },
      colors: ["#008FFB", "#FEB019"],
      xaxis: {
        type: "category",
      },
    },
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between graph__title__border bg-body-secondary"
        style={{ borderBottom: "1px solid rgb(229, 229, 229)" }}
      >
        <h6 className="m-0 fontSize12 fw-bold">BoxPlot Chart with Outliers</h6>
      </div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="boxPlot"
          height={300}
        />
      </div>
    </>
  );
};

export default BoxPlotChart;
